module.exports = __webpack_public_path__ + "fonts/PPRader-Bold.ae27f08.ttf";